import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import debounce from 'debounce'

import PageNav from '../PageNav/'
import IconNav from '../IconNav/'
import logo from '../../../assets/logo-mini.svg'
import { OuterWrap, Wrap, LogoContainer, PageNavContainer, IconNavContainer, Overlay } from './styles'

class StickyHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false
    }
  }

  handleSwitchBranch() {
    this.setState({
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
    this.props.onSwitchBranch()
  }

  handleUserMenuClick() {
    this.setState({
      userMenuActive: !this.state.userMenuActive,
      assortActive: false,
      companyActive: false,
      serviceActive: false,
    })
  }

  handleAssortClick() {
    this.setState({
      assortActive: !this.state.assortActive,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
  }

  handleCompanyClick() {
    this.setState({
      companyActive: !this.state.companyActive,
      userMenuActive: false,
      assortActive: false,
      serviceActive: false
    })
  }

  handleClickContact() {
    this.setState({
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
    this.props.onClickContact()
  }

  handleClickService() {
    this.setState({
      serviceActive: !this.state.serviceActive,
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
    })
  }

  handleClickOutside() {
    this.setState({
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
  }

  componentDidMount() {
    window.onscroll = debounce(this.handleScroll, 16)
  }

  handleScroll() {
    const height = 500
    const stickyHeader = document.querySelector('.js-sticky-header')

    if (stickyHeader) {
      if (window.pageYOffset > height) {
        if (!stickyHeader.classList.contains('active')) {
          stickyHeader.classList.add('active')
        }
      } else {
        if (stickyHeader.classList.contains('active')) {
          stickyHeader.classList.remove('active')
        }
      }
    }
  }

  render() {
    return (
      <Fragment>
        <OuterWrap className="js-sticky-header">
          <Wrap>
            <LogoContainer>
              <Link to="/">
                <img src={logo} alt="logo" width="52" height="52" />
              </Link>
            </LogoContainer>

            <PageNavContainer>
              <PageNav 
                permissions={this.props.permissions} 
                nrOfOrders={this.props.nrOfOrders}
                onClickAssort={this.handleAssortClick.bind(this)}
                assortActive={this.state.assortActive}
                onClickCompany={this.handleCompanyClick.bind(this)}
                companyActive={this.state.companyActive}
                onClickService={this.handleClickService.bind(this)}
                serviceActive={this.state.serviceActive}
              />
            </PageNavContainer>

            <IconNavContainer>
              <IconNav
                branchName={this.props.branchName}
                onSwitchBranch={this.handleSwitchBranch.bind(this)}
                handleLogout={this.props.handleLogout}
                permissions={this.props.permissions}
                gender={this.props.gender}
                onClickLink={this.handleUserMenuClick.bind(this)}
                userMenuActive={this.state.userMenuActive}
                onClickContact={this.handleClickContact.bind(this)}
              />
            </IconNavContainer>
          </Wrap>
        </OuterWrap>

        {this.state.assortActive || this.state.userMenuActive ? (
          <Overlay onClick={this.handleClickOutside.bind(this)} />
        ) : null}
      </Fragment>
    )
  }
}

export default withRouter(StickyHeader)



// WEBPACK FOOTER //
// ./src/components/Header/StickyHeader/index.js